<template>
    <table class="customizable-card-table">
        <tbody>
            <tr v-if="showCardImages">
                <th>
                    {{ $translate('card', 'Kreditkort') }}
                </th>
                <td v-for="(card, index) in cards" :key="index" class="align-top">
                    <nuxt-link v-if="card" :to="$prismic.linkResolver(card)" class="card-image-container">
                        <prismic-image :img="card.data.image" w="120" />
                        <span>
                            {{ card.data.title }}
                        </span>
                    </nuxt-link>
                </td>
            </tr>
            <tr
                v-for="(row, rowIndex) in rows"
                :key="rowIndex"
                :class="{'d-none': hasHiddenRows && !showAll && rowIndex > visibleCount}"
            >
                <th>
                    {{ tableTitles[rowIndex] }}
                </th>
                <td v-for="(cell, cellIndex) in row" :key="cellIndex">
                    <div class="rich-text col-text" v-html="cell" />
                </td>
            </tr>
            <tr 
                v-if="showOutLinks" 
                :class="{'d-none': hasHiddenRows && !showAll}"
            >
                <th class="table-header-application">
                    {{ $translate('application_label', 'Ansök') }}
                </th>
                <td v-for="(card, index) in cards" :key="index">
                    <ButtonTarget 
                        v-if="card" 
                        :link="card" 
                        background="orange"
                        size="sm"
                        class="application-button"
                    />
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        cards: {
            type: Array,
            required: true
        },
        tableTitles: {
            type: Array,
            required: true
        },
        tableData: {
            type: Array,
            required: true
        },
        showCardImages: {
            type: Boolean,
            required: false,
            default: false
        },
        showOutLinks: {
            type: Boolean,
            required: false,
            default: false
        },
        hasHiddenRows: {
            type: Boolean,
            required: false,
            default: false
        },
        initialVisibleCount: {
            type: Number,
            required: true
        },
        showAll: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        rows() {
            const rows = [];

            for (let i = 0; this.tableTitles.length > i; i++) {
                const rowValues = this.tableData
                    .map(row => row[i] || '');
                rows.push(rowValues);
            }
            return rows;
        },
        visibleCount() {
            return this.initialVisibleCount - (this.showCardImages ? 1 : 0);
        }
    }
};
</script>

<style lang="scss" scoped>
td {
    .application-button {
        width: fit-content;
        margin: 0 auto;
    }
}
</style>